// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"DeliveryTabs_PageHolder__1vjPB","TabsTitle":"DeliveryTabs_TabsTitle__3qt2r","normal":"DeliveryTabs_normal__3S5WS","checked":"DeliveryTabs_checked__37DIR"};